/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Offset_TimecodeInputs */

const en_shortcut_keys_name_offset_timecode = /** @type {(inputs: Shortcut_Keys_Name_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset Timecode`)
};

const fr_shortcut_keys_name_offset_timecode = /** @type {(inputs: Shortcut_Keys_Name_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decaler le timecode`)
};

const de_shortcut_keys_name_offset_timecode = /** @type {(inputs: Shortcut_Keys_Name_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset-Zeitcode`)
};

const it_shortcut_keys_name_offset_timecode = /** @type {(inputs: Shortcut_Keys_Name_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice temporale offset`)
};

const ru_shortcut_keys_name_offset_timecode = /** @type {(inputs: Shortcut_Keys_Name_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смещение временного кода`)
};

const es_shortcut_keys_name_offset_timecode = /** @type {(inputs: Shortcut_Keys_Name_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de tiempo de desplazamiento`)
};

const zh_cn2_shortcut_keys_name_offset_timecode = /** @type {(inputs: Shortcut_Keys_Name_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`偏移时间码`)
};

const ja_shortcut_keys_name_offset_timecode = /** @type {(inputs: Shortcut_Keys_Name_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オフセットタイムコード`)
};

const hi_shortcut_keys_name_offset_timecode = /** @type {(inputs: Shortcut_Keys_Name_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़सेट टाइमकोड`)
};

const pt_pt2_shortcut_keys_name_offset_timecode = /** @type {(inputs: Shortcut_Keys_Name_Offset_TimecodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de tempo de deslocamento`)
};

/**
* | output |
* | --- |
* | "Offset Timecode" |
*
* @param {Shortcut_Keys_Name_Offset_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_offset_timecode = /** @type {((inputs?: Shortcut_Keys_Name_Offset_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Offset_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_offset_timecode(inputs)
	if (locale === "de") return de_shortcut_keys_name_offset_timecode(inputs)
	if (locale === "it") return it_shortcut_keys_name_offset_timecode(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_offset_timecode(inputs)
	if (locale === "es") return es_shortcut_keys_name_offset_timecode(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_offset_timecode(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_offset_timecode(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_offset_timecode(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_offset_timecode(inputs)
	return en_shortcut_keys_name_offset_timecode(inputs)
});